import { useState, useEffect } from 'react';
import { client } from '../../sdkAdapter';

export default function Ping() {
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

    useEffect(() => {
        const checkPing = async () => {
            try {
                await client.getV1TestPing();
                setStatus('success');
            } catch (err) {
                console.error('Ping failed:', err);
                setStatus('error');
            }
        };

        checkPing();
    }, []);

    const getBadgeStyles = () => {
        switch (status) {
            case 'success':
                return 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400 border-green-200 dark:border-green-800';
            case 'error':
                return 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400 border-red-200 dark:border-red-800';
            default:
                return 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-400 border-gray-200 dark:border-gray-700';
        }
    };

    return (
        <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium border ${getBadgeStyles()}`}>
            <span className={`w-2 h-2 rounded-full ${status === 'loading' ? 'bg-gray-400 animate-pulse' : 'bg-current'}`}></span>
            {status === 'loading' && 'Checking...'}
            {status === 'success' && 'API Online'}
            {status === 'error' && 'API Offline'}
        </div>
    );
}
